import ConstCode from '@/common/constants/ConstCode';

export const isMobile = () => {
  let body = document.getElementsByTagName('body');
  return body[0].clientWidth < 1000;
  // return (screen.width < 1000)
};
export const isScrollBar = () => {
  return (
    (document.getElementById('test').scrollHeight === 0 && document.getElementById('test').clientHeight === 0) ||
    document.getElementById('test').scrollHeight > document.getElementById('test').clientHeight
  );
};
export const isApp = () => {
  const result = navigator.userAgent.indexOf(`${ConstCode.CODE_ENV_LIST.APP_SCHEMA}`) > -1;
  return result;
};
export const isSafari = () => {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent.toLowerCase());
};
export const isIPhone = () => {
  return /^((?!chrome|android).)*iphone/i.test(navigator.userAgent.toLowerCase());
};
export const isIPad = () => {
  return /^((?!chrome|android).)*ipad/i.test(navigator.userAgent.toLowerCase());
};

export default {
  isMobile,
  isScrollBar,
  isApp,
  isSafari,
  isIPhone,
  isIPad
};
